import {
  LuAudioLines, LuBot, LuChartColumn, LuCirclePlus, LuFlag, LuGauge, LuLayers, LuListFilter,
  LuMegaphone, LuMessagesSquare, LuPhone, LuPhoneCall, LuRadio, LuServer, LuTriangleAlert,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
// `exact` keeps detail pages (/voice/agents/4, /voice/calls/9) from starting a
// tab tour whose targets are not there. Tabs whose content is all data-driven
// open with a centred card (null target) so the tour still starts when empty.
const tours = [
  tour('voice', '/voice', 'voice', [
    ['tabs', 'voice.tabs', LuLayers],
    ['new', 'voice.new', LuBot, opt],
    ['kpis', 'voice.kpis', LuChartColumn, opt],
    ['calls', 'voice.calls', LuPhone, { placement: 'top', ...opt }],
  ], { exact: true }),
  tour('voice_agents', '/voice/agents', 'voice', [
    ['intro', null, LuBot],
    ['new', 'voice_agents.new', LuCirclePlus, opt],
    ['list', 'voice_agents.list', LuLayers, { placement: 'top', ...opt }],
  ], { exact: true }),
  tour('voice_calls', '/voice/calls', 'voice', [
    ['filters', 'voice_calls.filters', LuListFilter],
    ['review', 'voice_calls.review', LuFlag, opt],
    ['list', 'voice_calls.list', LuPhoneCall, { placement: 'top', ...opt }],
  ], { exact: true }),
  tour('voice_live', '/voice/live', 'voice', [
    ['intro', null, LuRadio],
    ['calls', 'voice_live.calls', LuPhoneCall, { placement: 'right', ...opt }],
    ['transcript', 'voice_live.transcript', LuMessagesSquare, { placement: 'left', ...opt }],
  ], { exact: true }),
  tour('voice_quality', '/voice/quality', 'voice', [
    ['views', 'voice_quality.views', LuLayers],
    ['kpis', 'voice_quality.kpis', LuGauge, opt],
    ['weakest', 'voice_quality.weakest', LuTriangleAlert, { placement: 'top', ...opt }],
  ], { exact: true }),
  tour('voice_campaigns', '/voice/campaigns', 'voice', [
    ['intro', null, LuMegaphone],
    ['new', 'voice_campaigns.new', LuCirclePlus, opt],
    ['list', 'voice_campaigns.list', LuLayers, { placement: 'top', ...opt }],
  ], { exact: true }),
  tour('voice_settings', '/voice/settings', 'voice', [
    ['add', 'voice_settings.add', LuCirclePlus],
    ['providers', 'voice_settings.providers', LuAudioLines, opt],
    ['trunks', 'voice_settings.trunks', LuServer, { placement: 'top', ...opt }],
    ['numbers', 'voice_settings.numbers', LuPhone, { placement: 'top', ...opt }],
  ], { exact: true }),
];

export default tours;
